<mat-card>
  <mat-card-content>
    <button mat-button (click)="showView()">&lt; All Personas</button>
    <h2>Create a reviewer persona</h2>
    <form [formGroup]="editPersonaFormGroup">
      <mat-form-field class="row">
        <mat-label>Title</mat-label>
        <input type="text" matInput placeholder="" formControlName="title" data-test-id="admin-personas-title-input" />
        <mat-hint>Name this reviewer. This is a fictional name. Try something memorable. </mat-hint>
        <mat-error *ngIf="editPersonaFormGroup.get('title')?.hasError('required')"
          >Please enter a valid title</mat-error
        >
        <mat-error *ngIf="editPersonaFormGroup.get('title')?.hasError('maxlength')"
          >Tile must be less than 100 characters</mat-error
        >
        <mat-error *ngIf="editPersonaFormGroup.get('title')?.hasError('nonUnique')">Tile must be unique</mat-error>
      </mat-form-field>
      <mat-form-field class="row">
        <mat-label>Summary</mat-label>
        <textarea
          matInput
          placeholder=""
          formControlName="summary"
          cdkTextareaAutosize
          cdkAutosizeMinRows="1"
          cdkAutosizeMaxRows="3"
          data-test-id="admin-personas-summary-input"></textarea>
        <mat-hint
          >Describe the reviewer's persona in under 500 characters. This summary will be visible to everyone who views
          the profile.</mat-hint
        >
        <mat-error *ngIf="editPersonaFormGroup.get('summary')?.hasError('required')"
          >Please enter a valid summary</mat-error
        >
        <mat-error *ngIf="editPersonaFormGroup.get('summary')?.hasError('maxlength')"
          >Summary must be less than 500 characters</mat-error
        >
      </mat-form-field>

      @if (currentStep !== ManagePersonasEditSteps.CREATE_TITLE) {
        <h3>Description</h3>
        <p>Write your own description of the persona or let us help you generate one by examples.</p>

        <mat-drawer-container class="description-row">
          <mat-drawer-content class="row2">
            <mat-form-field class="row2">
              <mat-label>Description</mat-label>
              <textarea
                matInput
                placeholder="Enter a description of the persona"
                formControlName="description"
                cdkTextareaAutosize
                cdkAutosizeMinRows="1"
                cdkAutosizeMaxRows="12"
                data-test-id="admin-personas-description-input"></textarea>
              <mat-error *ngIf="editPersonaFormGroup.get('description')?.hasError('required')"
                >Please enter a valid description.</mat-error
              >
              <mat-error *ngIf="editPersonaFormGroup.get('description')?.hasError('maxlength')"
                >Tile must be less than 2000 characters</mat-error
              >
              <mat-error
                *ngIf="
                  editPersonaFormGroup.get('description')?.hasError('minlength') &&
                  editPersonaFormGroup.get('description')?.dirty &&
                  editPersonaFormGroup.get('description')?.touched
                "
                >Tile must be more than 200 characters</mat-error
              >
            </mat-form-field>
            <button
              mat-fab
              extended
              *ngIf="!selectedPersona?.exampleDocuments || selectedPersona?.exampleDocuments?.length === 0"
              class="toggleGeneratePersonaButton"
              (click)="showUploadModule()"
              data-test-id="admin-personas-generate-ai-btn">
              <mat-icon>smart_toy</mat-icon>Generate Using Ai
            </button>
            <input
              type="file"
              #fileInputPersona
              style="display: none"
              accept="application/pdf"
              (input)="onPersonaUploadFiles($event)"
              multiple />
          </mat-drawer-content>
          <mat-drawer
            #drawer
            class=""
            mode="side"
            position="end"
            opened
            *ngIf="selectedPersona?.exampleDocuments && selectedPersona?.exampleDocuments?.length !== 0">
            <div class="flex-upload-column">
              <h3 class="">Example Documents</h3>
              <button
                mat-fab
                extended
                #addPersonaFile
                class="addPersonaFileButton"
                (click)="showUploadModule()"
                [disabled]="personaGenInProgress">
                <mat-icon>smart_toy</mat-icon>Add Documents
              </button>
              <span *ngFor="let doc of selectedPersona.exampleDocuments">
                <p matTooltip="{{ doc.file_id }}">{{ doc.file_id }}</p>
                <div class="flex-close-file">
                  <div class="progress-bar-container">
                    <mat-progress-bar  *ngIf="!isUploadingDoc(doc)" mode="determinate" value="{{ personaGenInProgress ? 0 : 100 }}"
                    ></mat-progress-bar>
                    <mat-progress-bar
                      *ngIf="isUploadingDoc(doc)"
                      mode="indeterminate"
                      color="accent"
                      style="width: 100%; height: 50px;">
                    </mat-progress-bar>
                  </div>
                  <button
                    mat-mini-fab
                    (click)="onPersonaFileRemove(doc)"
                    class="transparent_button"
                    [disabled]="personaGenInProgress">
                    <mat-icon color="tertiary">delete</mat-icon>
                  </button>
                </div>
              </span>
              <div class="loading-text" *ngIf="showDocLoadingText()" aria-live="polite">
                 Loading Documents...
              </div>
              <button mat-fab extended (click)="generatePersonaFromFileList(selectedPersona)" [disabled]="isUploading" data-test-id="admin-personas-generate-description-btn">
                Generate Description
              </button>
              @if (personaGenInProgress) {
                <div class="description-loading" data-test-id="admin-personas-generating-spinner">
                  <mat-spinner [diameter]="20"></mat-spinner>
                  <p>Generating description...</p>
                </div>
              }
            </div>
          </mat-drawer>
        </mat-drawer-container>
      }
      <div class="bottom-bar">
        <div class="bottom-bar-content">
          <button
            mat-flat-button
            class="padding-left-10 font-roboto-normal"
            [disabled]="editPersonaFormGroup.invalid"
            (click)="onSave()"
            data-test-id="admin-personas-save-btn">
            {{ currentStep === ManagePersonasEditSteps.CREATE_TITLE ? 'Save and Continue' : 'Save' }}
          </button>
          &nbsp;
          <button mat-flat-button (click)="showView()" class="padding-left-10 font-roboto-normal" data-test-id="admin-personas-cancel-btn">Cancel</button>
        </div>
      </div>
    </form>
  </mat-card-content>
</mat-card>
